import {
  CallScribeCallStatus,
  CallScribePipelineStage,
  ICallScribeCallListItem,
} from 'services/callScribe/types';
import { entryStillOwed } from 'components/CallScribe/postCallReviewPhase';

export const RECONCILE_MS = 10000;
export const RECONCILE_MAX_FETCHES = 30;

const IN_FLIGHT_STAGES: readonly CallScribePipelineStage[] = [
  CallScribePipelineStage.Received,
  CallScribePipelineStage.Transcribing,
  CallScribePipelineStage.Summarizing,
];

const ACTIVE_CALL_STATUSES: readonly CallScribeCallStatus[] = [
  CallScribeCallStatus.Initiated,
  CallScribeCallStatus.Ringing,
  CallScribeCallStatus.Answered,
];

const awaitsAutomaticPost = (call: ICallScribeCallListItem): boolean =>
  call.willPostAutomatically === true &&
  call.hasIntelligence &&
  entryStillOwed(call.linkStatus);

export const needsReconcile = (call: ICallScribeCallListItem | null): boolean => {
  if (call === null) {
    return false;
  }
  if (ACTIVE_CALL_STATUSES.includes(call.status)) {
    return true;
  }
  if (call.status !== CallScribeCallStatus.Completed) {
    return false;
  }
  if (awaitsAutomaticPost(call)) {
    return true;
  }
  if (call.pipelineStage === null) {
    return !call.hasIntelligence;
  }
  return IN_FLIGHT_STAGES.includes(call.pipelineStage);
};
